module.exports = __webpack_public_path__ + "static/IMG_6177-7b50ff349be9af2ce9b06c07f1ee4ec7.jpg";